(() => {
  const STYLE_ID = 'reobrix-account-glass-style';
  const LOGIN_FORM_STYLE_ID = 'reobrix-login-form-glass-style';

  const accountCss = `
    dialog {
      background:
        radial-gradient(circle at 18% 0%, rgba(255,255,255,.08), transparent 36%),
        linear-gradient(
          180deg,
          rgba(14,15,16,.38),
          rgba(8,9,10,.30),
          rgba(5,6,7,.38)
        ) !important;
      background-color: rgba(8,9,10,.32) !important;
      color: rgba(255,255,255,.92) !important;
      border: 1px solid rgba(255,255,255,.14) !important;
      box-shadow:
        0 24px 70px rgba(0,0,0,.34),
        inset 0 0 0 1px rgba(255,255,255,.05),
        inset 0 1px 0 rgba(255,255,255,.09) !important;
      backdrop-filter: blur(30px) saturate(150%) !important;
      -webkit-backdrop-filter: blur(30px) saturate(150%) !important;
    }

    dialog::backdrop {
      background: rgba(0,0,0,.16) !important;
      backdrop-filter: blur(4px) saturate(120%) !important;
      -webkit-backdrop-filter: blur(4px) saturate(120%) !important;
    }

    .account,
    .account *,
    .account__header,
    .account__header-region,
    .account__content,
    .account__main,
    .account__body {
      color: rgba(255,255,255,.92) !important;
      -webkit-text-fill-color: rgba(255,255,255,.92) !important;
      text-shadow: none !important;
    }

    .account__header {
      background: rgba(255,255,255,.035) !important;
      border-bottom: 1px solid rgba(255,255,255,.12) !important;
    }

    .account__heading {
      color: rgba(255,255,255,.94) !important;
      -webkit-text-fill-color: rgba(255,255,255,.94) !important;
    }

    .account__close,
    .account__close svg,
    .account__close path {
      background: rgba(255,255,255,.06) !important;
      color: rgba(255,255,255,.92) !important;
      fill: rgba(255,255,255,.92) !important;
      stroke: rgba(255,255,255,.92) !important;
    }

    button,
    a {
      border-color: rgba(255,255,255,.14) !important;
    }

    button[type="submit"],
    .shop-login-button,
    .shopify-login-button,
    [class*="shop"] button {
      filter: saturate(.86) brightness(.96) !important;
    }

    .account__secondary-action,
    .account__footer button,
    .account__footer a,
    [class*="orders"],
    [class*="profile"] {
      background: rgba(255,255,255,.045) !important;
      border: 1px solid rgba(255,255,255,.14) !important;
      color: rgba(255,255,255,.92) !important;
      -webkit-text-fill-color: rgba(255,255,255,.92) !important;
    }
  `;

  const loginFormCss = `
    :host {
      color: rgba(255,255,255,.92) !important;
    }

    label,
    label[for="login-form-email"],
    .login-form__email-label {
      display: none !important;
      opacity: 0 !important;
      visibility: hidden !important;
      pointer-events: none !important;
    }

    input,
    input[type="email"],
    #login-form-email,
    .login-form__email-input {
      background:
        linear-gradient(
          135deg,
          rgba(255,255,255,.05),
          rgba(255,255,255,.02)
        ) !important;
      background-color: rgba(5,8,12,.62) !important;
      border: 1px solid rgba(255,255,255,.16) !important;
      color: rgba(255,255,255,.95) !important;
      -webkit-text-fill-color: rgba(255,255,255,.95) !important;
      caret-color: rgba(255,255,255,.95) !important;
      box-shadow:
        inset 0 1px 0 rgba(255,255,255,.05),
        inset 0 0 18px rgba(0,0,0,.28) !important;
      outline: none !important;
      padding-top: 16px !important;
      padding-bottom: 16px !important;
    }

    input:focus,
    input[type="email"]:focus,
    #login-form-email:focus,
    .login-form__email-input:focus {
      background-color: rgba(5,8,12,.72) !important;
      border-color: rgba(255,255,255,.24) !important;
      box-shadow:
        inset 0 1px 0 rgba(255,255,255,.06),
        inset 0 0 18px rgba(0,0,0,.30),
        0 0 0 1px rgba(255,255,255,.08) !important;
    }

    input::placeholder,
    #login-form-email::placeholder,
    .login-form__email-input::placeholder {
      color: rgba(255,255,255,.42) !important;
      -webkit-text-fill-color: rgba(255,255,255,.42) !important;
    }

    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    #login-form-email:-webkit-autofill,
    .login-form__email-input:-webkit-autofill {
      -webkit-text-fill-color: rgba(255,255,255,.95) !important;
      caret-color: rgba(255,255,255,.95) !important;
      -webkit-box-shadow: 0 0 0 1000px rgba(5,8,12,.72) inset !important;
      box-shadow: 0 0 0 1000px rgba(5,8,12,.72) inset !important;
      transition: background-color 999999s ease-in-out 0s, color 999999s ease-in-out 0s !important;
    }

    button,
    button[type="submit"] {
      background: linear-gradient(135deg, #c91820, #a80f16) !important;
      background-color: #c91820 !important;
      color: #ffffff !important;
      -webkit-text-fill-color: #ffffff !important;
      border: 1px solid rgba(255,255,255,.12) !important;
    }

    svg,
    path {
      color: #ffffff !important;
      stroke: #ffffff !important;
      fill: #ffffff !important;
    }
  `;

  function injectStyle(root, id, cssText) {
    if (!root) return;

    const existingStyle = root.getElementById(id);

    if (existingStyle) {
      if (existingStyle.textContent !== cssText) {
        existingStyle.textContent = cssText;
      }
      return;
    }

    const style = document.createElement('style');
    style.id = id;
    style.textContent = cssText;
    root.appendChild(style);
  }

  function applyAccountGlass() {
    const hosts = document.querySelectorAll('shopify-account');

    hosts.forEach((host) => {
      const accountRoot = host.shadowRoot;
      if (!accountRoot) return;

      injectStyle(accountRoot, STYLE_ID, accountCss);

      const loginForms = accountRoot.querySelectorAll('shopify-login-form');

      loginForms.forEach((formHost) => {
        const formRoot = formHost.shadowRoot;
        if (!formRoot) return;

        injectStyle(formRoot, LOGIN_FORM_STYLE_ID, loginFormCss);
      });
    });
  }

  applyAccountGlass();

  const observer = new MutationObserver(applyAccountGlass);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  document.addEventListener('click', () => {
    setTimeout(applyAccountGlass, 50);
    setTimeout(applyAccountGlass, 250);
    setTimeout(applyAccountGlass, 800);
  });

  document.addEventListener('input', () => {
    setTimeout(applyAccountGlass, 50);
  });
})();
